import React from 'react'
import { FormattedMessage } from 'react-intl'

import capitalize from 'utils/capitalize'

import {
  IconsRowContainer,
  IconsRowIconWrapper,
  IconsRowsIcon,
  IconsRowsUsersNumberWrapper,
  IconsRowUsersNumber
} from './style'

const defaultIconColor = {
  0: '#FF9900',
  1: '#FFCB00',
  2: '#0AA1F4'
}

const defaultIconsLimit = 3
const defaultUserListLength = 1
const defaultIconPosition = 16
const defaultZIndex = 0
const defaultColor = 'rgba(233, 233, 233, 1)'
const getUserNameFirstChar = 0
const iconsLimit = 3

const IconsRow = ({ usersList, labelText = 'users' }) => {
  let renderIcons = []

  if (usersList.length < defaultUserListLength) {
    for (let i = 0; i < defaultIconsLimit; i++) {
      renderIcons.push(
        <IconsRowIconWrapper data-testid='row-icon-wrapper' left={`${defaultIconPosition * i}px`} zIndex={`${defaultZIndex - i}`} key={i}>
          <IconsRowsIcon backGroundColor={defaultColor} />
        </IconsRowIconWrapper>
      )
    }
  } else {
    renderIcons = usersList.map((user, index) => {
      if (index < iconsLimit) {
        const userInitial = user.User.firstName.charAt(getUserNameFirstChar)
        return (
          <IconsRowIconWrapper left={`${defaultIconPosition * index}px`} zIndex={`${defaultZIndex - index}`} key={user}>
            <IconsRowsIcon backGroundColor={defaultIconColor[index]}>{capitalize(userInitial)}</IconsRowsIcon>
          </IconsRowIconWrapper>
        )
      }
    })
  }

  if (renderIcons.length < defaultIconsLimit) {
    for (let i = renderIcons.length; i < defaultIconsLimit; i++) {
      renderIcons.push(
        <IconsRowIconWrapper left={`${defaultIconPosition * i}px`} zIndex={`${defaultZIndex - i}`} key={i}>
          <IconsRowsIcon backGroundColor={defaultColor} />
        </IconsRowIconWrapper>
      )
    }
  }

  return (
    <IconsRowContainer data-test="total-users" data-testid='test-icons-row-container'>
      {renderIcons}
      <IconsRowsUsersNumberWrapper data-test="total-users-count" data-testid='test-icons-row-number-wrapper'>
        <FormattedMessage id={labelText} />
        <IconsRowUsersNumber data-testid='test-icons-row-users-count'>({usersList.length})</IconsRowUsersNumber>
      </IconsRowsUsersNumberWrapper>
    </IconsRowContainer>
  )
}

export default IconsRow
